import React from "react";
import { FileText, Search } from "lucide-react";

function ManualTile({ name, href, external = false }) {
    const handleClick = () => {
        if (!href) return;
        if (external) {
            window.location.href = href;
        } else {
            window.location.href = href;
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className="w-[120px] min-h-[112px] rounded-[14px] border border-slate-200 bg-slate-50 p-3 flex flex-col justify-between text-left transition hover:bg-slate-100 hover:shadow-sm"
        >
            <div className="flex items-start justify-between gap-2">
                <div className="mt-1">
                    <FileText size={22} className="text-[#454545]" />
                </div>

                <div className="h-[28px] w-[28px] rounded-full bg-slate-200 grid place-items-center">
                    <Search size={13} className="text-[#454545]" />
                </div>
            </div>

            <div className="text-[14px] leading-[16px] font-medium text-[#454545] whitespace-pre-line">
                {name}
            </div>
        </button>
    );
}

export default function ManualiCard() {
    const items = [
        {
            name: "Manuale\nHACCP",
            href: "https://app.norma-haccp.com/manuale",
            external: true,
        },
        {
            name: "Procedure",
            href: "https://app.norma-haccp.com/procedure",
            external: true,
        },
        {
            name: "Allegati di\nGestione",
            href: "https://app.norma-haccp.com/allegati-gestione",
            external: true,
        },
        {
            name: "Audit\nHACCP",
            href: "https://app.norma-haccp.com/audit-haccp",
            external: true,
        },
    ];

    return (
        <section>
            <h3 className="text-[28px] leading-[33px] font-light text-[#454545] mb-3">
                Manuali
            </h3>

            <div
                className="bg-white border border-slate-200 rounded-2xl p-4"
                style={{
                    boxShadow:
                        "0px 20px 25px rgba(0,0,0,0.10), 0px 2px 4px rgba(0,0,0,0.10)",
                }}
            >
                <div className="flex flex-wrap gap-3">
                    {items.map((item) => (
                        <ManualTile
                            key={item.name}
                            name={item.name}
                            href={item.href}
                            external={item.external}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}